export const validationRules = {
    creditCardName: {
        required: true,
        maxLength: 35,
        noWhiteSpace: true
    },
    // expirationDate: {
    //     required: true,
    //     format: /^\d{2}\/\d{2}\/\d{4}$/
    // },
    // securityCode: {
    //     required: true
    // }
};


// WEBPACK FOOTER //
// ./src/components/Payment/validationRules.ts